<template>
    <k-panel class="tranche-card" :classes="'border-l border-b border-r flex'">
        <template v-slot:header>
            <div class="card-image">
                <img v-if="tranche.mainPictureFileReference" class="rounded object-scale-down"
                     :src="`/api/guest/download/${tranche.mainPictureFileReference}`" onerror="this.src=`https://via.placeholder.com/800`">
            </div>
        </template>
        <div class="card-content border-gray-100 flex flex-col flex-1">
            <div>
                <k-panel-row class="mt-1">
                    <div slot="left">
                        <span class="font-semibold text-sm text-gray-900">{{ tranche.details.title }}</span>
                    </div>
                </k-panel-row>
                <k-panel-row class="mt-1">
                    <div slot="left">
                        <span class="font-semibold text-sm text-gray-900">{{ tranche.maturityDate | dateFormat }}</span>
                    </div>
                    <div slot="right">
                        <span v-if="tranche.capitalCallEnabled" class="font-medium text-xs text-gray-900">Early redemption</span>
                        <img v-if="tranche.capitalCallEnabled" src="/img/icon/dot_03_m.svg" class="inline-block icon">
                        <span class="font-medium text-xs text-gray-900" v-if="unsecuredTranche">Unsecured</span>
                        <span class="font-medium text-xs text-gray-900" v-else>Secured</span>
                    </div>
                </k-panel-row>
            </div>
            <div class="flex-1">
                <k-panel-row margin="mt-2 mb-10" v-if="tranche.details.summary && tranche.details.summary.shortDescription">
                    <div slot="left" class="pt-2">{{ tranche.details.summary.shortDescription }}</div>
                </k-panel-row>

                <k-panel-row margin="mb-1">
                    <div slot="left">
                        Industry
                    </div>
                    <div slot="right">
                        {{ tranche.trancheType | enumValue }}
                    </div>
                </k-panel-row>

                <k-panel-row margin="mb-1" v-if="tranche.details.expectedReturnPerYear">
                    <div slot="left">
                        Expected Return per year
                    </div>
                    <div slot="right">
                        {{ tranche.details.expectedReturnPerYear | numeralFormat('0.00') }}%
                    </div>
                </k-panel-row>

                <k-panel-row margin="mb-1">
                    <div slot="left">
                        Interest rate
                    </div>
                    <div slot="right">{{ tranche.interestRate | numeralFormat('0.00') }}%</div>
                </k-panel-row>
                <k-panel-row v-if="tranche.collateral" margin="mb-1">
                    <div slot="left">
                        Collateral
                    </div>
                    <div slot="right">
                        <div v-for="collateral in tranche.collateral" :key="collateral" class="text-right">
                            {{ collateral }}&nbsp;
                        </div>
                    </div>
                </k-panel-row>
                <k-panel-row margin="mb-1">
                    <div slot="left">
                        Early redemption frequency ({{ tranche.paymentPeriodInTerms }})
                    </div>
                    <div slot="right">{{ tranche.capitalCallEnabled ? tranche.capitalCallFrequency : 'No' }}</div>
                </k-panel-row>

                <k-panel-row margin="mb-1">
                    <div slot="left">
                        Currency
                    </div>
                    <div slot="right">{{ tranche.currencySymbol }} ({{ tranche.currencyCode }})</div>
                </k-panel-row>

                <k-panel-row margin="mb-1">
                    <div slot="left">
                        Available to invest
                    </div>
                    <div slot="right">{{ tranche.currencySymbol }}{{
                            tranche.principalAvailable | numeralFormat('0,0.')
                        }}
                    </div>
                </k-panel-row>

                <k-panel-row margin="mb-1">
                    <div slot="left">
                        Minimum investment
                    </div>
                    <div slot="right">{{ tranche.nominalValue | numeralFormat('0,0.') }}</div>
                </k-panel-row>
            </div>
            <div class="mb-1 mt-5 w-auto flex block">
                <div class="flex-grow">
                    <a-button type="primary" @click="invest" class="inline-block">
                        {{ $t("invest") }}
                    </a-button>
                </div>
                <div>
                    {{ tranche.debenturesSold | numeralFormat('0,0.')}} bonds sold
                </div>
            </div>
        </div>
    </k-panel>
</template>

<script>
export default {
    props: {
        tranche: {
            type: Object,
            default: () => ({})
        },
    },
    methods: {
        invest (item) {
            this.$emit('invest', item.uuid)
        }
    },
    computed: {
        unsecuredTranche() {
            return _.includes(this.tranche.collateral, 'Unsecured');
        },
    },
};
</script>

<style scoped>
.card-image {
    width: 100%;
    min-height: 200px;
    /*height: 200px;*/
    overflow: hidden;
    position: relative;
}

.card-image img {
    width: 100%;
    height: auto;
    max-height: 258px;
    transition: all .5s;
    transform: scale(1.05);
}

.tranche-card {
    padding: 0;
    cursor: pointer;
}

.tranche-card:hover .card-image img {
    transform: scale(1.10);
}

.tranche-card:hover {
    @apply bg-gray-100;
}

.card-content {
    padding: 20px;
}

.icon {
    height: 12px;
    width: 12px;
}
</style>
